import { Textbox } from "components/Textbox/Textbox";
import { Button } from "components/Button/Button";
import { useEffect, useState } from "react";
import { Response } from "types/types";
import { Loading } from "components/Loading/loading";
import {
  getSalesContractStatus,
  postSalesContractStatusApi,
  putSalesContractStatusApi,
} from "./api";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
interface Prop {
  resetForm?: boolean;
  onHide: () => void;
  selectedObj?: any;
  mode: string;
  reload: () => void;
}
interface Form {
  Name: string;
  Code: string;
}
export const SalesContractStatusForm = ({
  reload,
  onHide,
  mode,
  selectedObj,
}: Prop) => {
  const [resetForm, setResetForm] = useState(false);
  const [response, setResponse] = useState<Response | any>();
  const [userChanges, setUserChanges] = useState({});
  const [loading, setLoading] = useState<any>();

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  async function getSalesContractStatusId() {
    setLoading(false);
    try {
      const data = await getSalesContractStatus(selectedObj?.Id);
      setResponse(data.Data);
    } catch (error) {}
    setLoading(true);
  }

  const submit = (e) => {
    e.preventDefault();
    if (response == null) {
      postSalesContractStatusApi({
        IsDefault: e.target.SalesContractStatusCheckbox.checked,
        Title: e.target.SalesContractStatusTitle.value,
        TitleEN: e.target.SalesContractStatusTitleEN.value,
        SystemKey: e.target.SalesContractStatusSystemKey.value,
      }).then(() => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        reload();
      });
    } else {
      putSalesContractStatusApi({
        IsDefault: e.target.SalesContractStatusCheckbox.checked,
        Title: e.target.SalesContractStatusTitle.value,
        TitleEN: e.target.SalesContractStatusTitleEN.value,
        SystemKey: e.target.SalesContractStatusSystemKey.value,
        ActivityStatus: +e.target.SalesContractStatusSelect.value,
        Id: selectedObj?.Id,
      }).then(() => {
        sessionStorage.setItem("changingforms", "false");
        setResponse(null);
        setUserChanges({});
        reload();
      });
    }
  };

  useEffect(() => {
    if (selectedObj && mode != "create") {
      getSalesContractStatusId();
    } else {
      setResponse(null);
      setLoading(true);
    }
  }, [selectedObj, mode]);

  useEffect(() => {
    if (resetForm) {
      setUserChanges({});
      setResponse(null);
    }
  }, [resetForm]);

  return (
    <>
      <div className="card mb-4">
        {loading ? (
          <form className="TypeSettingForm row card-body " onSubmit={submit}>
            <div className="col-md-4 col-sm-12">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                required={true}
                textboxName={"SalesContractStatusTitle"}
                textboxType="text"
                resetForm={resetForm}
                labelText={"Title"}
                mode={mode}
                defaultValue={response?.Title}
              />
            </div>
            <div className="col-md-4 col-sm-12">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                required={true}
                textboxName={"SalesContractStatusTitleEN"}
                textboxType="text"
                resetForm={resetForm}
                labelText={"TitleEN"}
                mode={mode}
                defaultValue={response?.TitleEN}
              />
            </div>
            <div className="col-md-4 col-sm-12">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                required={true}
                textboxName={"SalesContractStatusSystemKey"}
                textboxType="systemKey"
                resetForm={resetForm}
                labelText={"systemKey"}
                mode={mode}
                defaultValue={response?.SystemKey}
              />
            </div>
            {mode != "create" && (
              <div className="col-lg-4 mt-1">
                <EnumerationTypeSelect
                  Change={(e) => {
                    setUserChanges({ ...userChanges, ...e });
                  }}
                  name="SalesContractStatusSelect"
                  mode={mode}
                  label="Status"
                  enumTypeSelect="ActivityStatus"
                  value={response?.ActivityStatus}
                />
              </div>
            )}
            <div className=" mt-4 mb-4">
              <CheckableButton
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                defaultChecked={response?.IsDefault}
                defaultValue={response?.IsDefault}
                labelText={"IsDefault"}
                inputName={"SalesContractStatusCheckbox"}
                type="checkbox"
                mode={mode}
              />
            </div>
            {mode != "view" ? (
              <div className="col-lg-12 mt-1 btns_form">
                <Button value="Save" btnType="submit" />
                <Button
                  btnType="cancel"
                  value="Cancel"
                  onClick={() => {
                    onHide();
                  }}
                />
              </div>
            ) : (
              <div className="col-lg-12 mt-1 btns_form">
                <Button
                  btnType="primary"
                  value="close"
                  onClick={() => {
                    onHide();
                  }}
                />
              </div>
            )}
          </form>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};
